import {
  ChangeDetectorRef,
  Component,
  inject,
  input,
  viewChildren,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { QuestionKind } from '@core/interview-templates-types';
import {
  BadgeComponent,
  BoxComponent,
  HeadingComponent,
  DividerComponent,
  RadioComponent,
} from '@core/user-interface-legacy';

import type { QuestionBase } from '../interview-kind';
import { QuestionRefDirective } from '../question-ref.directive';

interface SkillRatingControls {
  skillId: FormControl<number>;
  skillName: FormControl<string>;
  skillDescription: FormControl<string | null>;
  proficiencyId: FormControl<number | null>;
  options: FormControl<Array<{ value: number; option: string; description: string | null }>>;
}
type SkillRatingControl = FormGroup<SkillRatingControls>;

interface SkillsQuestionControls extends QuestionBase {
  questionKind: FormControl<QuestionKind.Skills>;
  skillRatings: FormArray<SkillRatingControl>;
}
export type SkillsQuestionControl = FormGroup<SkillsQuestionControls>;

@Component({
  selector: 'rt-interview-skills',
  templateUrl: 'interview-skills.component.html',
  styleUrls: ['./interview-skills.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    BoxComponent,
    HeadingComponent,
    TranslatePipe,
    BadgeComponent,
    DividerComponent,
    RadioComponent,
    QuestionRefDirective,
  ],
})
export class InterviewSkillsComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  protected readonly RequiredValidator = Validators.required;

  public readonly questionForm = input.required<SkillsQuestionControl>();
  public readonly hasProtectedControls = input.required<boolean>();
  public readonly formSubmissionAttempt = input<boolean>(false);

  public readonly questionRefList = viewChildren(QuestionRefDirective);

  protected get skillsCount(): number {
    return this.questionForm().controls.skillRatings.length ?? 0;
  }

  protected selectProficiency(
    skillControl: SkillRatingControl,
    selectedProficiencyId: number,
  ): void {
    skillControl.controls.proficiencyId.setValue(selectedProficiencyId);
    skillControl.controls.proficiencyId.updateValueAndValidity();
    skillControl.markAsTouched();
    this.cdRef.detectChanges();
  }
}
